import { formatForDisplay, formatToLocalTimeString } from '@/lib/time'

export function formatDuration(ms: number): string {
  const totalSeconds = Math.floor(ms / 1000)
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60
  return `${minutes}:${seconds.toString().padStart(2, '0')}`
}

export function formatElapsed(seconds: number): string {
  const safeSeconds = Number.isFinite(seconds) ? Math.max(0, seconds) : 0
  const totalSeconds = Math.floor(safeSeconds)
  const hours = Math.floor(totalSeconds / 3600)
  const mins = Math.floor((totalSeconds % 3600) / 60)
  const secs = totalSeconds % 60
  return [hours, mins, secs].map((part) => part.toString().padStart(2, '0')).join(':')
}

// Both drafts and submissions store time as MM/DD/YYYY HH:MM:SS (with seconds for sorting).
// Display format removes seconds: MM/DD/YYYY HH:MM.
export function getDisplayDate(createdAt: string): string {
  if (createdAt.includes('/') && createdAt.includes(':')) {
    return formatForDisplay(createdAt)
  }
  return formatForDisplay(formatToLocalTimeString(createdAt))
}
